import { TableFilterType, TableSortType } from '../../../components/table/table-object';
import { SortTypeEnum } from '../../../types';

// Partner Review Report Utils
export function mapPartnerFilters(filters: TableFilterType[]) {
    if (!filters.length) return {};
    let mappedFilters: { [key: string]: string } = {};
    filters.forEach((item) => {
        if (item.dataIndex === 'reportedByCompanyName') {
            mappedFilters['ReportedByCompanyName.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportedOnCompanyName') {
            mappedFilters['ReportedOnCompanyName.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'contractComplianceState') {
            mappedFilters['ContractComplianceState.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reviewType') {
            mappedFilters['ReviewType.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportedDate' && item.value) {
            mappedFilters['ReportedDateText.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportStatus') {
            mappedFilters['ReportStatus.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportedById') {
            mappedFilters['ReportedById.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportedByName') {
            mappedFilters['ReportedByName.FilterValue'] = item.value;
        }
    });
    return mappedFilters;
}

export function mapPartnerSort(sort: TableSortType) {
    let mappedSort: { [key: string]: SortTypeEnum } = {};
    if (sort.dataIndex === 'reportedByCompanyName') {
        mappedSort['ReportedByCompanyName.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportedOnCompanyName') {
        mappedSort['ReportedOnCompanyName.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'contractComplianceState') {
        mappedSort['ContractComplianceState.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reviewType') {
        mappedSort['ReviewType.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportedDate') {
        mappedSort['ReportedDate.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportStatus') {
        mappedSort['ReportStatus.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportedById') {
        mappedSort['ReportedById.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportedByName') {
        mappedSort['ReportedByName.SortType'] = sort.value;
    }
    return mappedSort || 'ReportedDate.SortType';
}

export function mapFilters(filters: TableFilterType[]) {
    if (!filters.length) return {};
    let mappedFilters: { [key: string]: string } = {};
    filters.forEach((item) => {
        if (item.dataIndex === 'reportedBy') {
            mappedFilters['ReportedBy.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'candidateName') {
            mappedFilters['CandidateName.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'companyName') {
            mappedFilters['CompanyName.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'offerType') {
            mappedFilters['OfferType.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reviewType') {
            mappedFilters['ReviewType.FilterValue'] = item.value;
        }
        if (item.dataIndex === 'reportedDateFilter' && item.value) {
            mappedFilters['ReportedDateFilter.FilterValue'] = item.value.trim();
        }
        if (item.dataIndex === 'currentStatus') {
            mappedFilters['CurrentStatus.FilterValue'] = item.value;
        }
    });
    return mappedFilters;
}

export function mapSort(sort: TableSortType) {
    let mappedSort: { [key: string]: SortTypeEnum } = {};
    if (sort.dataIndex === 'reportedBy') {
        mappedSort['ReportedBy.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'candidateName') {
        mappedSort['CandidateName.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'companyName') {
        mappedSort['CompanyName.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'offerType') {
        mappedSort['OfferType.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reviewType') {
        mappedSort['ReviewType.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'reportedDateFilter') {
        mappedSort['ReportedDateSort.SortType'] = sort.value;
    }
    if (sort.dataIndex === 'currentStatus') {
        mappedSort['CurrentStatus.SortType'] = sort.value;
    }
    return mappedSort;
}
